























import { Component, Vue, Prop } from "vue-property-decorator";
import CardInputResep from "@/components/pemeriksaan/CardInputResep.vue";
import CardListResepIgd from "@/components/resep/CardListResepIgd.vue";
import { resepStore } from "@/store/modules/resep";
import { appModule } from "@/store/modules/app";
import http from "@/axios/http-common";
import { userModule } from "@/store/modules/user";

@Component({
  components: {
    CardInputResep,
    CardListResepIgd
  }
})
export default class ResepIgdGroup extends Vue {
  dataExample = "";
  listResep = [];
  activeResep = {};
  timeout = 2000;

  @Prop() register: number;

  @Prop() rm: number;

  mounted() {
    this.getResepList(this.register).then(() => {
      const userResep = resepStore.resep.filter(resep => {
        return resep.dokter.id == userModule.user.id;
      });

      if (userResep.length) {
        this.setActiveResep(userResep[userResep.length - 1]);
      }
    });
  }

  get stateuser() {
    return userModule.user;
  }

  get loading() {
    return appModule.loading;
  }

  get mode() {
    return appModule.mode;
  }

  get snackbar() {
    return appModule.snackbar;
  }

  get notice() {
    return appModule.notice;
  }

  get showInputResep() {
    return this.stateuser.profesi == "Dokter" && this.activeResep !== null;
  }

  updateResepList() {
    this.getResepList(this.register);
  }

  setActiveResep(val) {
    this.activeResep = val;

    console.log("set active resep", val);
  }

  getResepList(reg) {
    resepStore.SET_LIST_LOADING(true);

    return http
      .getData(`/register/${reg}/resep-obat-text`)
      .then(response => {
        resepStore.setResep(response.data.data);
      })
      .then(() => {
        resepStore.SET_LIST_LOADING(false);
      });
  }

  addResep() {
    this.activeResep = {};
    resepStore.showInputResep();
  }
}
